import React, { Component } from "react";

import PontoInteresse from "./pontos_interesse/PontoInteresse";

import { Link } from "react-router-dom";

import { Element } from "react-scroll";

import PropTypes from "prop-types";

import axios from "axios";

export default class AquiPerto extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      aquiPerto: [],
    };
  }

  componentDidMount = () => {
    this.loadAquiPerto();
  };

  loadAquiPerto = async () => {
    let res = {};
    try {
      res = await axios.get("api/pontosInteresse", {
        params: {
          type: "AQUI_PERTO",
          limit: 4,
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let aquiPerto = res.data.arrayPontos;

    this.setState({ aquiPerto: aquiPerto });
  };

  pontoClicked = (id) => {
    this.context.router.history.push("/aqui_perto/" + id);
  };

  render() {
    const items = this.state.aquiPerto.map((item, index) => {
      return (
        <PontoInteresse
          POIClicked={() => this.pontoClicked(item.identifier)}
          ponto={item}
          key={item.identifier}
          number={index}
        ></PontoInteresse>
      );
    });

    return (
      <section id="aqui-perto">
        <Element name="aquiPertoElement"></Element>
        <div className="container">
          <h1>Aqui Perto</h1>

          {items.length === 0 ? (
            <>
            <p>
              Os pontos perto da nossa aldeia encontram-se inacessíveis. 
            </p>
            <p>Aproveite para conhecer melhor a aldeia do Sabugueiro.</p>
            </>
          ) : (
            <>
              <div className="row">{items}</div>
              <div className="see-more">
                <Link to={"/aqui_perto"}>
                  Ver mais<i className="fas fa-angle-right"></i>
                </Link>
              </div>
            </>
          )}
        </div>
      </section>
    );
  }
}
